<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M2.34375 12.5C2.34375 6.89086 6.89086 2.34375 12.5 2.34375C18.1091 2.34375 22.6562 6.89086 22.6562 12.5C22.6562 18.1091 18.1091 22.6562 12.5 22.6562C6.89086 22.6562 2.34375 18.1091 2.34375 12.5ZM14.1955 8.42008C13.2697 7.60997 11.7308 7.60997 10.805 8.42008C10.4803 8.70421 9.9867 8.6713 9.70258 8.34659C9.41845 8.02187 9.45135 7.52831 9.77607 7.24418C11.291 5.91861 13.7095 5.91861 15.2244 7.24418C16.8005 8.62328 16.8005 10.908 15.2244 12.2871C14.9571 12.521 14.6626 12.7126 14.3521 12.8629C13.6477 13.2038 13.2815 13.6689 13.2815 14.0625V14.8438C13.2815 15.2752 12.9317 15.625 12.5002 15.625C12.0688 15.625 11.719 15.2752 11.719 14.8438V14.0625C11.719 12.7302 12.8224 11.8673 13.6715 11.4564C13.8617 11.3643 14.038 11.249 14.1955 11.1112C15.0602 10.3546 15.0602 9.17666 14.1955 8.42008ZM12.5 18.75C12.9315 18.75 13.2812 18.4002 13.2812 17.9688C13.2812 17.5373 12.9315 17.1875 12.5 17.1875C12.0685 17.1875 11.7188 17.5373 11.7188 17.9688C11.7188 18.4002 12.0685 18.75 12.5 18.75Z"
				:fill="color"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgQuestion',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>